import React from 'react';
import { Icon } from '../../Icon/Icon';

export interface PatientPrepRowProps {
  label: string;
  on: boolean;
  critical?: boolean;
}

export function PatientPrepRow({ label, on, critical }: PatientPrepRowProps) {
  return (
    <div className="pt-prep-row">
      <span
        className="pt-prep-check"
        style={{
          background: on
            ? 'var(--success-tint)'
            : critical
              ? 'var(--terracotta-tint)'
              : 'var(--surface-mute)',
          color: on ? 'var(--success)' : critical ? 'var(--terracotta)' : 'var(--ink-4)',
        }}
      >
        <Icon kind={on ? 'check' : 'x'} size={10} stroke={2.8} />
      </span>
      <span
        style={{
          color: on ? 'var(--ink-2)' : critical ? 'var(--terracotta)' : 'var(--ink-3)',
          fontWeight: on ? 500 : critical ? 600 : 500,
        }}
      >
        {label}
      </span>
    </div>
  );
}
